<template>
  <div class="background-darker price-calculator-small">
    <div class="uk-padding-large">
      <h2 class="no-border">Bereken de prijs</h2>
      <h3>Wat voor productie ga je maken?</h3>

      <ButtonSelector :buttons="buttons" @change="changeActiveOne"/>

      <div class="uk-margin-medium-top" :class="{'uk-hidden': !isOther}">
        <hr>
        <p>
          Voor veel soorten producties heb ik de prijzen online staan, maar het kan natuurlijk
          altijd zijn dat je iets heel specifieks wilt. Of speciale opties. Je kunt het beste
          even direct
          <router-link to="/contact">contact met mij opnemen</router-link>
          .
        </p>
      </div>
      <div class="uk-margin-medium-top" :class="{'uk-hidden': !isAudiobook}">
        <hr>
        <p>
          Leuk, Een audioboek! Audioboeken worden afgerekend per af-uur. Dat is de netto-tijd
          die overblijft na het schoonmaken en monteren van de audiobestanden.
          prijsconstructies mogelijk waarbij ik uitbetaald wordt in een percentage van de
          opbrengsten van de productie.<br>
          Voor audioboeken kun je beste
          <router-link to="/contact">
            contact met mij opnemen
          </router-link>
        </p>
        <div class="uk-flex uk-flex-center uk-child-width-1-4 price-blocks">
          <div>
            <h4>Per af-uur</h4>
            <span class="price">{{  priceCalculator('audiobook') }}</span>
          </div>
        </div>
      </div>

      <div class="uk-margin-medium-top" :class="{'uk-hidden': !isVideo}">
        <h3>Hoeveel woorden moeten er opgenomen worden?</h3>
        <RangeSlider min="1"
                     max="5001"
                     step="1"
                     defaultValue="100"
                     valueSuffix="woorden"
                     minLabel="0"
                     maxLabel="5000+"
                     @change="totalWords = $event"
        />
        <div class="uk-flex-around price-blocks" uk-grid>
          <div>
            <h4>Aantal woorden</h4>
            <span class="price">{{ totalWordsFormatted }}</span>
          </div>
          <div>
            <h4>Prijsindicatie</h4>
            <span class="price">{{  priceCalculator('video', totalWords) }}</span>
          </div>
        </div>
        <div class="uk-margin-large-top uk-text-center">
          <router-link :to="requestUrl"
                       class="uk-button uk-button-default uk-margin-auto">
            Voice Over Aanvragen
          </router-link>
        </div>
      </div>

      <div class="uk-margin-medium-top" :class="{'uk-hidden': !isIVR}">
        <h3>Hoeveel woorden moeten er opgenomen worden?</h3>
        <RangeSlider min="1"
                     max="501"
                     step="1"
                     defaultValue="20"
                     valueSuffix="woorden"
                     minLabel="0"
                     maxLabel="500+"
                     @change="totalWordsIVR = $event"
        />
        <div class="uk-flex-around price-blocks" uk-grid>
          <div>
            <h4>Aantal woorden</h4>
            <span class="price">{{ totalWordsIVR }}</span>
          </div>
          <div>
            <h4>Prijsindicatie</h4>
            <span class="price">{{  priceCalculator('ivr', totalWordsIVR) }}</span>
          </div>
        </div>
        <div class="uk-margin-large-top uk-text-center">
          <router-link :to="requestUrl"
                       class="uk-button uk-button-default uk-margin-auto">
            Voice Over Aanvragen
          </router-link>
        </div>
      </div>

      <div class="uk-margin-medium-top" :class="{'uk-hidden': !isCommercial}">
        <h3>Voor welk medium?</h3>
        <div class="uk-flex-center uk-child-width-1-3" uk-grid>
          <div>
            <BigRadioButton label="Online" name="commercial-medium"
                            index="online"
                            :value="commercialMedium"
                            @change="commercialMedium = $event"/>
          </div>
          <div>
            <BigRadioButton label="Radio" name="commercial-medium"
                            index="radio"
                            :value="commercialMedium"
                            @change="commercialMedium = $event"/>
          </div>
          <div>
            <BigRadioButton label="Televisie" name="commercial-medium"
                            index="tv"
                            :value="commercialMedium"
                            @change="commercialMedium = $event"/>
          </div>
        </div>
        <hr>
        <div :class="{'uk-hidden': isOnlineCommercial}">
          <h3>En welk bereik?</h3>
          <div class="uk-flex-around uk-child-width-1-3" uk-grid>
            <div>
              <BigRadioButton label="Lokaal" name="commercial-reach"
                              :value="commercialReach"
                              index="local"
                              @change="commercialReach = $event"/>
            </div>
            <div>
              <BigRadioButton label="Regionaal" name="commercial-reach"
                              :value="commercialReach"
                              index="regional"
                              @change="commercialReach = $event"/>
            </div>
            <div>
              <BigRadioButton label="Landelijk" name="commercial-reach"
                              :value="commercialReach"
                              index="national"
                              @change="commercialReach = $event"/>
            </div>
          </div>
          <hr>
        </div>
        <div class="uk-margin-medium-top"
             :class="{'uk-hidden': !(isCommercial && mediumAndReachChosen)}"
        >
          <h3>Hoe lang duurt de commercial?</h3>
          <RangeSlider
            min="30"
            max="120"
            defaultValue="30"
            step="15"
            minLabel="30 seconden"
            maxLabel="120 seconden"
            outputSuffix="seconden"
            @change="commercialLength = $event"
          />
          <div class="uk-flex-around uk-child-width-1-5 price-blocks" uk-grid>
            <div>
              <h4>Buy-out</h4>
              <span class="price">
                {{
                  priceCalculator(
                    'commercial',
                    commercialLength,
                    commercialMedium,
                    commercialReach
                  ).buyout
                }}
              </span>
            </div>
            <div>
              <h4>Opnamefee</h4>
              <span class="price">
                {{
                  priceCalculator(
                    'commercial',
                    commercialLength,
                    commercialMedium,
                    commercialReach
                  ).fee
                }}
              </span>
            </div>
            <div>
              <h4>Prijsindicatie</h4>
              {{
                priceCalculator(
                  'commercial',
                  commercialLength,
                  commercialMedium,
                  commercialReach
                ).total
              }}
            </div>
          </div>

          <div class="uk-margin-large-top uk-text-center">
            <router-link :to="requestUrl"
                         class="uk-button uk-button-default uk-margin-auto">
              Voice Over Aanvragen
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BigRadioButton from '@/components/BigRadioButton.vue';
import RangeSlider from '@/components/RangeSlider.vue';
import ButtonSelector from '@/components/ButtonSelector.vue';
import priceCalculator from '@/assets/content/priceCalculator';
import buttons from '@/assets/content/buttons';

const numberFormatterInstance = new Intl.NumberFormat('nl-NL');
const numberFormatter = (number) => numberFormatterInstance.format(number);

export default {
  name: 'PriceCalculatorSmall.vue',
  components: { RangeSlider, BigRadioButton, ButtonSelector },
  data() {
    return {
      type: 'video',
      selectedButton: 'bedrijfsfilm',
      commercialReach: undefined,
      commercialMedium: undefined,
      commercialLength: 30,
      totalWords: 100,
      totalWordsIVR: 20,
    };
  },
  methods: {
    changeActiveOne(btn) {
      this.type = btn.type;
      this.selectedButton = btn.title;
    },
    priceCalculator,
  },
  computed: {
    buttons() {
      return buttons(this.$route.query.selectedButton ?? 'bedrijfsfilm');
    },
    requestUrl(query = {}) {
      const params = {
        amountOfWords: (this.type === 'ivr' ? this.totalWordsIVR : this.totalWords),
        typeOfProduction: this.type,
        selectedButton: this.selectedButton,
        commercialReach: this.commercialReach,
        commercialMedium: this.commercialMedium,
        ...query,
      };

      return '/voice-over-aanvragen/'
        + `?amountOfWords=${encodeURIComponent(params.amountOfWords)}`
        + `&typeOfProduction=${encodeURIComponent(params.typeOfProduction)}`
        + `&selectedButton=${encodeURIComponent(params.selectedButton)}`
        + `&commercialReach=${encodeURIComponent(params.commercialReach)}`
        + `&commercialMedium=${encodeURIComponent(params.commercialMedium)}`;
    },
    isCommercial() {
      return (this.type === 'commercial');
    },
    isIVR() {
      return (this.type === 'ivr');
    },
    isOther() {
      return (this.type === 'other');
    },
    isAudiobook() {
      return (this.type === 'audiobook');
    },
    isVideo() {
      return (this.type === 'video');
    },
    isOnlineCommercial() {
      return (this.isCommercial && this.commercialMedium === 'online');
    },
    mediumAndReachChosen() {
      return (
        this.commercialMedium === 'online' || (
          !!this.commercialReach && !!this.commercialMedium
        )
      );
    },
    totalWordsFormatted() {
      return numberFormatter(this.totalWords);
    },
  },
};
</script>
